<template>
  <div class="lxn-w100 lxn-h100">
    <div class="SingleSwitchWidget-wrapper-switch lxn-margin-auto">
      <SingleThreewaySwitch @timerClicked="timerClicked()" @switchClicked="toggleOutput()" :state="currentSwitchState" :widgeetMode="widgetMode" :bgColorOn="widgetColor" bgColorOff="#ACB8BF" bgColorPending="#CCCCCC" handleColorOn="#FFFFFF" handleColorOff="#FFFFFF" :disabled="isHubOffline" />
    </div>
    <div class="SingleSwitchWidget-wrapper-text lxn-w100 lxn-text-center lxn-text" :style="currentSwitchStateColor" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
      {{currentSwitchStateText}}
    </div>
  </div>
</template>

<script>

import SingleThreewaySwitch from '@/components/SingleThreewaySwitch.vue';
import * as CONFIGS from '@/statics/configs.js';
import NODE2 from '@/statics/devices/Node2/header.js';
import NODE5 from '@/statics/devices/Node5/header.js';
import Logger from '@/statics/logger.js';
import Messaging from '@/statics/messaging.js';

export default {
  name: 'SingleThreewaySwitchWidget',
  props: {
    index: Number
  },
  components: {
    SingleThreewaySwitch,
  },
  data: function () {
    return {
      switchLocked: false,
      switchStatus: 0,
      // widgetStatus: "off"
    }
  },
  // watch: {
  //   switchState: function (newVal) {
  //     this.currentSwitchState = (newVal == 1) ? 'on' : 'off';
  //   },
  // },
  // mounted: function () {
  //   this.currentSwitchState = this.switchState == 1 ? 'on' : 'off';
  // },
  computed: {
    nodeHeader: function () {
      if (this.node.deviceType == 5) {
        return NODE5
      }else{
        return NODE2
      }
    },
    widget: function () {
      return this.$store.state.widgets[this.index];
    },
    timeDelay: function () {
      return this.widget.timeDelay;
    },
    widgetColor: function () {
      return this.$store.state.themeMainColors[this.widget.color];
    },
    node: function () {
      return this.$store.getters.getNodeByUUID(this.widget.nodeUUIDs[0]);
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.widget.hubUUID);
    },
    output: function () {
      return this.node.outputs[this.widget.settings.outputIndex];
    },
    input: function () {
      // we want in1 -> out1 and in2 -> out2 so their index is the same 
      return this.node.inputs[this.widget.settings.outputIndex];
    },
    switchState: function () {
      var switchState = this.$store.getters.getParameterValue(this.node.index, this.output.parameterId);
      if(switchState == undefined){
        return 0;
      }else{
        return switchState;
      }
    },
    widgetMode: function () {
      return this.widget.mode; 
    }, 
    currentSwitchState: function () {
    
      return (this.switchState == 1) ? 'on' : 'off';
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    currentSwitchStateText: function () {
      if(this.isNodeOffline){
        return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Unknown;
      }else{
        if(this.widgetMode == 'auto'){
          if(this.currentSwitchState == 'on'){
          return `${this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Auto} - ${this.$store.getters.language.texts.RelaySSR2ASettings_switchState_On}`;
        }else if(this.currentSwitchState == 'off'){
          return `${this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Auto} - ${this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Off}`;
        }else{
          return 'undefined'
        }
        }
        else if(this.currentSwitchState == 'on'){
          return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_On;
        }else if(this.currentSwitchState == 'off'){
          return this.$store.getters.language.texts.RelaySSR2ASettings_switchState_Off;
        }else{
          return 'undefined'
        }
      }
    },
    currentSwitchStateColor: function () {
      if(this.isNodeOffline){
        return 'color: #FF946B';
      }else{
        if (this.widgetMode == 'auto'){
          return 'color: #52626C';
        }
        if(this.currentSwitchState == 'on'){
          return 'color: ' + this.widgetColor;
        }else if(this.currentSwitchState == 'off'){
          return 'color: #52626C';
        }else{
          return 'color: #ffffff';
        }
      }
    },
    normallyClosed: function () {
      var normallyClosed = this.widget.normallyClosed == true;
      return normallyClosed;
    }
  },
  methods: {
    modifyInstructionsParameterId: function (instructions) {
      for (let i=0; i < instructions.length;i++){
        let instruction = instructions[i];
        if (instruction.eventToWatch.parameterId == NODE5.INPUT1.PARAMETER_ID) {
          instruction.eventToWatch.parameterId = this.input.parameterId;
        } else if (instruction.eventToWatch.parameterId == NODE5.OUTPUT1.PARAMETER_ID) {
          instruction.eventToWatch.parameterId = this.output.parameterId;
        }
        if (instruction.internalAction.parameterId == NODE5.OUTPUT1.PARAMETER_ID) {
          instruction.internalAction.parameterId = this.output.parameterId;
        } else if (instruction.internalAction.parameterId == NODE5.NOTIFY_HUB.PARAMETER_ID) {
          instruction.internalAction.parameterId = this.nodeHeader.NOTIFY_HUB.PARAMETER_ID;
        } else  { //if (instruction.internalAction.parameterId === CONFIGS.CLEAR_PENDING_ACTIONS_ON_OUTPUT1)
          if (this.widget.settings.outputIndex == 0) {
            instruction.internalAction.parameterId = CONFIGS.CLEAR_PENDING_ACTIONS_ON_OUTPUT1;
          } else {
            instruction.internalAction.parameterId = CONFIGS.CLEAR_PENDING_ACTIONS_ON_OUTPUT2;
          }
        }
        instructions[i] = instruction;
      }
      return instructions;
    }, 
    resetEventIdForNotifyHubInstructions: function (newInstructions, oldInstructions){
      // we want to check if there is an old instruction for notify hub with a particular eventId and preserve it, 
      // changing the oldinstruction eventids could result in messing up the notifications
      for (let i=0; i < newInstructions.length; i++) {
        let newInstruction = newInstructions[i];
        if (newInstruction.internalAction.parameterId == this.nodeHeader.NOTIFY_HUB.PARAMETER_ID) {
          for (let j=0; j < oldInstructions.length; j++) {
            let oldInstruction = oldInstructions[j]; 
            if (newInstruction.eventToWatch.parameterId == oldInstruction.eventToWatch.parameterId && newInstruction.eventToWatch.valueToReach == oldInstruction.eventToWatch.valueToReach && oldInstruction.internalAction.parameterId == this.nodeHeader.NOTIFY_HUB.PARAMETER_ID){
              newInstructions[i].internalAction.valueOfChange = oldInstruction.internalAction.valueOfChange;
            }
          }
        } 
      }
      return newInstructions;
    },
    timerClicked: function (togggleOutputClicked) {
      
      if (this.switchLocked === false){
        setTimeout(() => {  console.log("World!"); }, 3000);
        this.$store.commit('setAppBusy', true);
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: false,
        });
        this.switchLocked = true;
        if (this.widgetMode === "auto") {
          let instrunctionsToSet = [];
          if (this.normallyClosed){
            instrunctionsToSet.push(...NODE5.DIRECT_INSTRUCTIONS_TO_NOTIFY_HUB);
          } else {
            instrunctionsToSet.push(...NODE5.DIRECT_INSTRUCTIONS_TO_NOTIFY_HUB);
          }
          let newInstrunctionsToSet = JSON.parse(JSON.stringify(instrunctionsToSet));
          newInstrunctionsToSet = this.modifyInstructionsParameterId(newInstrunctionsToSet);
          let messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid,
          });
          this.$store.dispatch("readNodeInstructions", {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.node.uuid,
            })
            .then((response) => {
              let nodeInstructions = response.body.bodyContent.instructionList;
              let oldInstructions = []
              newInstrunctionsToSet = this.resetEventIdForNotifyHubInstructions(newInstrunctionsToSet, nodeInstructions);
              for (let i=0; i < nodeInstructions.length ; i++) {
                let instruction = nodeInstructions[i]
                if (instruction.eventToWatch.parameterId != this.input.parameterId && instruction.eventToWatch.parameterId != this.output.parameterId){
                  oldInstructions.push(instruction);
                }
              }
              let allInstructions = [
                ...oldInstructions,
                ...newInstrunctionsToSet
              ]
              this.$store.dispatch("setInstructionsOnDevice", {
                messagingHook: messagingHook,
                hubUUID: this.hub.uuid,
                nodeUUID: this.node.uuid,
                // nodeUUID: undefined,
                instructions: allInstructions,
              }).then((response) => {
                // successfull
                this.$store.commit("updateWidgetProperty", {
                  widgetIndex: this.index,
                  property: "mode",
                  propertyValue: "manual"
                });
                this.$store.commit("saveState");
              }).catch((response) => {
                this.$store.commit("setAppBusy", false);
                alert(`${this.$store.getters.language.texts.AlertٔNodeFailed} + ${response}`);            
              })  
            }).catch((response) => {
                this.$store.commit("setAppBusy", false);
                alert(`${this.$store.getters.language.texts.AlertٔNodeFailed} + ${response}`);            
              }).finally(() => {
                this.switchLocked = false
                this.$store.commit('setHubStatus', {
                  hubIndex: this.hub.index,
                  stateUpdateEnabled: true,
                });
                // after changing auto mode to manual mode, we will toggle the output.
                if (togggleOutputClicked) {
                  this.toggleOutput();
                }
              });
          
        } else { // widget.mode === "manual"
          let instrunctionsToSet = [];
          if (this.normallyClosed){
            let indirectInstructionsToSetOutput = NODE5.INDIRECT_INSTRUCTIONS_TO_SET_OUTPUT;
            for (let i=0; i < indirectInstructionsToSetOutput.length; i++){
                if (indirectInstructionsToSetOutput[i].internalAction.valueOfChange == 0) {
                  indirectInstructionsToSetOutput[i].timeDelay = this.timeDelay;
                }
              }
            instrunctionsToSet.push(...indirectInstructionsToSetOutput);
            instrunctionsToSet.push(...NODE5.DIRECT_INSTRUCTIONS_TO_NOTIFY_HUB_ON_TIMER);
            instrunctionsToSet.push(...NODE5.INDIRECT_INSTRUCTIONS_TO_CLEAR_PENDING_INSTRUCTIONS);
          } else {
            let directInstructionsToSetOutput = NODE5.DIRECT_INSTRUCTIONS_TO_SET_OUTPUT
            for (let i=0; i < directInstructionsToSetOutput.length; i++){
              if (directInstructionsToSetOutput[i].internalAction.valueOfChange == 0) {
                directInstructionsToSetOutput[i].timeDelay = this.timeDelay
              }
            }
          
            instrunctionsToSet.push(...directInstructionsToSetOutput);
            instrunctionsToSet.push(...NODE5.DIRECT_INSTRUCTIONS_TO_NOTIFY_HUB_ON_TIMER);
            instrunctionsToSet.push(...NODE5.DIRECT_INSTRUCTIONS_TO_CLEAR_PENDING_INSTRUCTIONS);
          }
          let newInstrunctionsToSet = JSON.parse(JSON.stringify(instrunctionsToSet));
          newInstrunctionsToSet = this.modifyInstructionsParameterId(newInstrunctionsToSet);
          let messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid,
          });
          this.$store.dispatch("readNodeInstructions", {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.node.uuid,
            })
            .then((response) => {
              let nodeInstructions = response.body.bodyContent.instructionList;
              let oldInstructions = []
              newInstrunctionsToSet = this.resetEventIdForNotifyHubInstructions(newInstrunctionsToSet, nodeInstructions);
              for (let i=0; i < nodeInstructions.length ; i++) {
                let instruction = nodeInstructions[i]
                if (instruction.eventToWatch.parameterId != this.input.parameterId &&  instruction.eventToWatch.parameterId != this.output.parameterId){
                  oldInstructions.push(instruction);
                }
              }
              let allInstructions = [
                ...oldInstructions,
                ...newInstrunctionsToSet
              ]
              this.$store.dispatch("setInstructionsOnDevice", {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.node.uuid,
              instructions: allInstructions,
            }).then((response) => {
              // successfull
              this.$store.commit("updateWidgetProperty", {
                widgetIndex: this.index,
                property: "mode",
                propertyValue: "auto"
              });
              this.$store.commit("saveState");
            }).catch((response) => {
              this.$store.commit("setAppBusy", false);
              alert(`${this.$store.getters.language.texts.AlertٔNodeFailed}  -- ${response}`);            
            })
            }).catch((response) => {
              this.$store.commit("setAppBusy", false);
              alert(`${this.$store.getters.language.texts.AlertٔNodeFailed}  -- ${response}`);            
            }).finally(() => {
            });
        }
        this.$store.commit("setAppBusy", false);
        this.$store.commit("setHubStatus", {
              hubIndex: this.hub.index,
              stateUpdateEnabled: true,
            });
        this.switchLocked = false;
      }
    },
    toggleOutput: function () {
      if(!this.switchLocked){
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: false,
        });        
        this.switchLocked = true;
        this.$store.commit('setAppBusy', true);
        if (this.widgetMode !== "auto"){
          if(this.currentSwitchState == 'on'){
            var valueOfChange = 0;
            if(this.normallyClosed){
              valueOfChange = 0;
            }
          }else{
            valueOfChange = 1;
            if(this.normallyClosed){
              valueOfChange = 1;
            }
          }
          this.$store.commit('setParameterValue', {nodeIndex: this.node.index, parameterId: this.output.parameterId, parameterValue: valueOfChange});
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          this.$store.dispatch('setNodesParameters', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
            bodyContent: {
              nodeActions: [
                {
                  nodeUUID: this.node.uuid,
                  actions: [
                    {
                      parameterId: this.output.parameterId,
                      valueOfChange: valueOfChange,
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    }
                  ]
                },
              ]
            }
          })
          .then( () => {
            this.switchLocked = false;
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            this.switchLocked = false;
            this.$store.commit('setAppBusy', false);
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
          })
          .finally( () => {
            this.$store.commit('setHubStatus', {
              hubIndex: this.hub.index,
              stateUpdateEnabled: true,
            });
          });
        } else { // else of if (this.widgetMode === "auto")          
          this.switchLocked = false
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
          this.timerClicked(true);
          return;
        }
      }
    },
  },
}
</script>

<style scoped> 
  .SingleSwitchWidget-wrapper-switch {
    height: 40px;
    width: 60%;
    margin: auto;
    padding-top: 10px;
  }
  .SingleSwitchWidget-wrapper-switch .SingleSwitchGeneral {
    /* height: 40px; */
    width: 100%;
    text-align: center;
    /* margin: auto; */
    /* padding-top: 10px; */
  }
  .SingleSwitchWidget-wrapper-text {
    height: 30px;
    line-height: 34px;
  }
</style>
